"use strict";

var ModuleGeneral = function ModuleGeneral() { };

import Swiper from "swiper/js/swiper.min.js";
import riot from "riot";

import "es6-promise/auto"; // IE11
import "fetch-polyfill"; // IE11

const objectAssign = require("object-assign"); //IE11 glottologistに作用させたいため現在は未使用

const glot = require("./lang.js"); //language

import validate from "jquery-validation";
import * as AutoKana from "vanilla-autokana";
var Moji = require("moji");

$(function () {
    /*
     ** riot
     */
    require("../../../views/header-tpl.tag");
    require("../../../views/footer-tpl.tag");
    //バスツアー2022特設ページ用にヘッダーを作成
    require("../../../views/header-tpl-bustour2022.tag");
    //第一回進撃の日田検定用にヘッダーとフッターを生成
    require("../../../views/header-tpl-quiz01.tag");
    require("../../../views/footer-tpl-quiz01.tag");
    riot.mount("*");

    /*
     ** object fit for IE
     */
    var objectFitImages = require("object-fit-images");
    objectFitImages("img.obj_img");
    objectFitImages("img.obj_img_contain");

    // 電話番号自動付与（sp）
    var ua = navigator.userAgent;
    if (
        ua.indexOf("iPhone") > 0 ||
        ua.indexOf("Android") > 0 ||
        ua.indexOf("iPad") > 0
    ) {
        $(".checkTel").each(function () {
            var str = $(this).text();
            $(this).html(
                $("<a>")
                    .attr("href", "tel:" + str.replace(/-/g, ""))
                    .append(str + "</a>")
            );
        });
    }

    //ハンバーガーメニュー indexのみ
    $("#nav-toggle").on("click", function () {
        $("body").toggleClass("open");
    });

    //もっとみる
    $(".switch").on("click", function () {
        $(this).next().toggleClass("open");
        $(this).toggleClass("on");
    });

    var TopBtn = $(".totop");
    var BottomPos = 15; // ボタンの画面下からの位置を指定
    TopBtn.hide();
    $(window).on("scroll", function (e) {
        var $window = $(e.currentTarget);
        var WindowHeight = $window.height(); // ウィンドウの高さ
        var PageHeight = $(document).height(); // ページの高さ
        var footerHeight = $("footer").height(); // フッタの高さ
        var ScrollTop = $window.scrollTop(); // スクロールした量
        var MoveTopBtn = WindowHeight + ScrollTop + footerHeight - PageHeight;

        //スクロール位置が100でボタンを表示
        if ($(this).scrollTop() > 100) {
            TopBtn.fadeIn();
        } else {
            TopBtn.fadeOut();
        }

        // フッターまでスクロールするとボタンを移動
        if (ScrollTop >= PageHeight - WindowHeight - footerHeight + BottomPos) {
            TopBtn.css({ bottom: MoveTopBtn });
        } else {
            TopBtn.css({ bottom: BottomPos });
        }
    });

    /*
     ** ios hover not working
     */
    const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);
    if (isIOS) {
        $(".lang").on("click", function () {
            var state = $(".lang_wrap").hasClass("on");
            if (!state) {
                $(".lang_wrap").addClass("on");
            } else {
                $(".lang_wrap").removeClass("on");
            }
        });

        $(document).on("click", function (e) {
            if (e.target.closest(".lang_wrap") == null) {
                $(".lang_wrap").removeClass("on");
            }
        });
    } else {
        $(".lang_wrap").on("mouseover", function () {
            $(this).addClass("on");
        });
        $(".lang_wrap").on("mouseleave", function () {
            $(this).removeClass("on");
        });
    }

    //ボタンを押下するとトップへ移動
    /*
  TopBtn.click(function() {
    $('body,html').animate({
      scrollTop: 0
    }, 300);
    return false;
  });
  */

    /*
     ** Swiper
     */
    if ($("#keyvisual").length) {
        var mySwiper = new Swiper(".swiper_container_kv", {
            initialSlide: 0,
            slidesPerView: 1,
            speed: 1200,
            loop: true,
            autoplay: {
                delay: 3000,
                reverseDirection: true,
            },
            spaceBetween: 0,
        });
    }
    if ($("#keyvisual_sp").length) {
        var mySwiper = new Swiper(".swiper_container_kv_sp", {
            slidesPerView: 1,
            direction: "vertical",
            speed: 1400,
            loop: true,
            autoplay: {
                delay: 3000,
                reverseDirection: true,
            },
            spaceBetween: 0,
        });
    }

    if ($(".guidance").length) {
        var mySwiper = new Swiper(".guidance_swiper_1", {
            slidesPerView: 1,
            // freeMode: true,
            speed: 400,
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".guidance_swiper_1 .swiper-button-next",
                prevEl: ".guidance_swiper_1 .swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        var mySwiper = new Swiper(".guidance_swiper_2", {
            slidesPerView: 1,
            speed: 400,
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".guidance_swiper_2 .swiper-button-next",
                prevEl: ".guidance_swiper_2 .swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        var mySwiper = new Swiper(".guidance_swiper_3", {
            slidesPerView: 1,
            speed: 400,
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".guidance_swiper_3 .swiper-button-next",
                prevEl: ".guidance_swiper_3 .swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        var mySwiper = new Swiper(".guidance_swiper_4", {
            slidesPerView: 1,
            speed: 400,
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".guidance_swiper_4 .swiper-button-next",
                prevEl: ".guidance_swiper_4 .swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                999: {
                    slidesPerView: 1,
                },
            },
        });
    }
    if ($(".museum_NewDisplay_postcard_slide").length) {
        var galleryThumbs = new Swiper(".museum_NewDisplay_postcard_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        var galleryTop = new Swiper(".museum_NewDisplay_postcard_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".museum_NewDisplay_slide").length) {
        var galleryThumbs = new Swiper(".museum_NewDisplay_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        var galleryTop = new Swiper(".museum_NewDisplay_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".colossal_titan_ar_slide").length) {
        var galleryThumbs = new Swiper(".colossal_titan_ar_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        var galleryTop = new Swiper(".colossal_titan_ar_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".ceremony_slide").length) {
        var galleryThumbs = new Swiper(".ceremony_slide_thumb", {
            initialSlide: 7,
            spaceBetween: 10,
            slidesPerView: 4,
            loop: true,
            freeMode: true,
            loopedSlides: 5,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".ceremony_slide", {
            initialSlide: 7,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".levi_statue_slide").length) {
        var galleryThumbs = new Swiper(".levi_statue_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            loop: true,
            freeMode: true,
            loopedSlides: 5,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".levi_statue_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".museum_slide").length) {
        var sliderThumbs = new Swiper(".museum_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            loop: true,
            freeMode: true,
            loopedSlides: 3,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: sliderThumbs,
            },
        });
    }

    if ($(".bus_tour_slide").length) {
        var galleryThumbs = new Swiper(".bus_tour_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".bus_tour_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".plumwine_slide").length) {
        var thumb = new Swiper(".plumwine_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".plumwine_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".mangaexpo_slide").length) {
        var thumb = new Swiper(".mangaexpo_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".mangaexpo_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".oyama_5th_slide").length) {
        var thumb = new Swiper(".oyama_5th_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".oyama_5th_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".erwin_acsta_slide").length) {
        var thumb = new Swiper(".erwin_acsta_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".erwin_acsta_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".fest_rth_slide").length) {
        var thumb = new Swiper(".fest_rth_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".fest_rth_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".hita_fest_burger_slide").length) {
        var thumb = new Swiper(".hita_fest_burger_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".hita_fest_burger_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }

    if ($(".hita_fest_deco_104_slide").length) {
        var thumb = new Swiper(".hita_fest_deco_104_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".hita_fest_deco_104_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".hita_fest_deco_slide").length) {
        var thumb = new Swiper(".hita_fest_deco_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".hita_fest_deco_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".evi_5th_ann_slide").length) {
        var thumb = new Swiper(".evi_5th_ann_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".evi_5th_ann_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".evi_5th_rpt_slide").length) {
        var thumb = new Swiper(".evi_5th_rpt_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".evi_5th_rpt_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".news_talkshow0301_slide").length) {
        var thumb = new Swiper(".news_talkshow0301_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".news_talkshow0301_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".hitafest_goal_slide").length) {
        var thumb = new Swiper(".hitafest_goal_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 8,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".hitafest_goal_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".eren_birthday2026_slide").length) {
        var thumb = new Swiper(".eren_birthday2026_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 8,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".eren_birthday2026_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".eren_birthday2026_bag_slide").length) {
        var thumb = new Swiper(".eren_birthday2026_bag_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 8,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".eren_birthday2026_bag_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".newgoods_bookmark_slide").length) {
        var thumb = new Swiper(".newgoods_bookmark_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".newgoods_bookmark_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".eren_birthfest2026_slide").length) {
        var thumb = new Swiper(".eren_birthfest2026_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".eren_birthfest2026_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".ts_WAK_slide").length) {
        var thumb = new Swiper(".ts_WAK_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".ts_WAK_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".oyama_5th_anniv_rpt_slide").length) {
        var thumb = new Swiper(".oyama_5th_anniv_rpt_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".oyama_5th_anniv_rpt_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".scas_slide").length) {
        var thumb = new Swiper(".scas_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".scas_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".collabo_slide").length) {
        var galleryThumbs = new Swiper(".collabo_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".collabo_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".cafe2f_open_slide").length) {
        var thumb = new Swiper(".cafe2f_open_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 9,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".cafe2f_open_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }

    if ($(".statue_1stAnniversary_slide").length) {
        var galleryThumbs = new Swiper(".statue_1stAnniversary_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".statue_1stAnniversary_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".statue_polishing_slide").length) {
        var galleryThumbs = new Swiper(".statue_polishing_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".statue_polishing_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".sendai_slide").length) {
        var galleryThumbs = new Swiper(".sendai_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".sendai_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".sendai_en_slide").length) {
        var galleryThumbs = new Swiper(".sendai_en_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".sendai_en_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".levi_statue_1st_anniversary_slide").length) {
        var galleryThumbs = new Swiper(
            ".levi_statue_1st_anniversary_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(".levi_statue_1st_anniversary_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".levi_statue_1st_anniversary_polishing_slide").length) {
        var galleryThumbs = new Swiper(
            ".levi_statue_1st_anniversary_polishing_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(
            ".levi_statue_1st_anniversary_polishing_slide",
            {
                initialSlide: 0,
                spaceBetween: 0,
                loop: true,
                loopedSlides: 3,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            }
        );
    }
    if ($(".museum_1st_anniversary_slide").length) {
        var galleryThumbs = new Swiper(".museum_1st_anniversary_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_1st_anniversary_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".museum_2nd_anniversary_slide").length) {
        var galleryThumbs = new Swiper(".museum_2nd_anniversary_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_2nd_anniversary_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".bus_tour_2022_slide").length) {
        var galleryThumbs = new Swiper(".bus_tour_2022_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".bus_tour_2022_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($("#dedicated_page").length) {
        var KV_SLIDER = new Swiper(".dedicated_page_kv", {
            initialSlide: 0,
            slidesPerView: 1,
            speed: 1500,
            loop: true,
            spaceBetween: 0,
            effect: "fade",
            allowTouchMove: false,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        var thumb1 = new Swiper(".thumb_1", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".slider_1", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb1,
            },
        });

        var thumb2 = new Swiper(".thumb_2", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".slider_2", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb2,
            },
        });

        var thumb3 = new Swiper(".thumb_3", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".slider_3", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb3,
            },
        });

        var thumb4 = new Swiper(".thumb_4", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".slider_4", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb4,
            },
        });
    }
    if ($(".deco104_2_slide").length) {
        var thumb = new Swiper(".deco104_2_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".deco104_2_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }

    if ($(".clb_slide_01").length) {
        var galleryThumbs = new Swiper(".clb_slide_01_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".clb_slide_01", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".clb_slide_02").length) {
        var galleryThumbs = new Swiper(".clb_slide_02_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".clb_slide_02", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".clb_slide_03").length) {
        var galleryThumbs = new Swiper(".clb_slide_03_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".clb_slide_03", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".levi_birthday_shopper2025_slide").length) {
        var thumb = new Swiper(".levi_birthday_shopper2025_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".levi_birthday_shopper2025_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".levi_birthday_fest2025_slide").length) {
        var thumb = new Swiper(".levi_birthday_fest2025_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".levi_birthday_fest2025_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".levi_birthday2025_slide").length) {
        var thumb = new Swiper(".levi_birthday2025_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".levi_birthday2025_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
        if ($(".mikasa_birthday2026_slide").length) {
        var thumb = new Swiper(".mikasa_birthday2026_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".mikasa_birthday2026_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
            if ($(".mikasa_birthday2026_coaster_slide").length) {
        var thumb = new Swiper(".mikasa_birthday2026_coaster_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".mikasa_birthday2026_coaster_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".hinamatsuri2026_slide").length) {
        var thumb = new Swiper(".hinamatsuri2026_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        new Swiper(".hinamatsuri2026_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumb,
            },
        });
    }
    if ($(".nta_slide").length) {
        var galleryThumbs = new Swiper(".nta_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".nta_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".shingeki_no_hita_cafe_open_slide").length) {
        var galleryThumbs = new Swiper(
            ".shingeki_no_hita_cafe_open_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(".shingeki_no_hita_cafe_open_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".museum_visitors_150k_slide").length) {
        var galleryThumbs = new Swiper(".museum_visitors_150k_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_visitors_150k_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".ar_release_2022_summer_2_slide").length) {
        var galleryThumbs = new Swiper(
            ".ar_release_2022_summer_2_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(".ar_release_2022_summer_2_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    if ($(".museum_visitors_200k_slide").length) {
        var galleryThumbs = new Swiper(".museum_visitors_200k_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_visitors_200k_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 大山ミュージアム25万人
    if ($(".museum_visitors_250k_slide").length) {
        var galleryThumbs = new Swiper(".museum_visitors_250k_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_visitors_250k_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 大山ミュージアム25万人
    if ($(".museum_visitors_250k_kr_slide").length) {
        var galleryThumbs = new Swiper(".museum_visitors_250k_kr_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_visitors_250k_kr_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // ANNEX1周年
    if ($(".annex_1st_anniv_info_slide").length) {
        var galleryThumbs = new Swiper(".annex_1st_anniv_info_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".annex_1st_anniv_info_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 大山ダム銅像4周年
    if ($(".oyama_statue_4th_slide").length) {
        var galleryThumbs = new Swiper(".oyama_statue_4th_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".oyama_statue_4th_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 池袋縁日POPUP
    if ($(".ikebukuro_popup_2411_slide").length) {
        var galleryThumbs = new Swiper(".ikebukuro_popup_2411_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".ikebukuro_popup_2411_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // スタンプラリー
    if ($(".stamp_rally_slide").length) {
        var galleryThumbs = new Swiper(".stamp_rally_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".stamp_rally_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // クーポン
    if ($(".coupon_slide").length) {
        var galleryThumbs = new Swiper(".coupon_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".coupon_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　スタンプラリー＆クーポン
    if ($(".stamp_rally_coupon_slide").length) {
        var galleryThumbs = new Swiper(".stamp_rally_coupon_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".stamp_rally_coupon_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　大山ダム２周年
    if ($(".oyama_statue_2nd_anniversary_event_slide").length) {
        var galleryThumbs = new Swiper(
            ".oyama_statue_2nd_anniversary_event_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(
            ".oyama_statue_2nd_anniversary_event_slide",
            {
                initialSlide: 0,
                spaceBetween: 0,
                loop: true,
                loopedSlides: 3,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            }
        );
    }
    // 新着情報　ミュージアム新グッズ
    if ($(".museum_new_items_slide").length) {
        var galleryThumbs = new Swiper(".museum_new_items_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_new_items_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　スタンプラリー　北九州
    if ($(".stamp_rally_kitakyushu_slide").length) {
        var galleryThumbs = new Swiper(".stamp_rally_kitakyushu_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".stamp_rally_kitakyushu_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　リヴァイ像3周年
    if ($(".levi_statue_3rd_info_slide").length) {
        var galleryThumbs = new Swiper(".levi_statue_3rd_info_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".levi_statue_3rd_info_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　大山ミュージアム3周年
    if ($(".oyama_museum_3rd_info_slide").length) {
        var galleryThumbs = new Swiper(".oyama_museum_3rd_info_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".oyama_museum_3rd_info_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　大山ミュージアム3周年
    if ($(".wrapping_train_slide").length) {
        var galleryThumbs = new Swiper(".wrapping_train_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".wrapping_train_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　缶バッジ新発売
    if ($(".tands_budge_school_slide").length) {
        var galleryThumbs = new Swiper(".tands_budge_school_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".tands_budge_school_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　缶バッジ再販
    if ($(".tands_budge_levi_slide").length) {
        var galleryThumbs = new Swiper(".tands_budge_levi_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 8,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".tands_budge_levi_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報スターフライヤー
    if ($(".starflyer_panel_slide").length) {
        var galleryThumbs = new Swiper(".starflyer_panel_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".starflyer_panel_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　リヴァイ像3周年_終了報告
    if ($(".levi_statue_3rd_slide").length) {
        var galleryThumbs = new Swiper(".levi_statue_3rd_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".levi_statue_3rd_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　共通券
    if ($(".combination_ticket_slide").length) {
        var galleryThumbs = new Swiper(".combination_ticket_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".combination_ticket_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　植樹終了報告
    if ($(".memorial_tree_report_slide").length) {
        var galleryThumbs = new Swiper(".memorial_tree_report_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".memorial_tree_report_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　トークショー終了報告
    if ($(".talk_show_report_slide").length) {
        var galleryThumbs = new Swiper(".talk_show_report_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".talk_show_report_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 進撃の日田公式スポットグッズ_ポストカード
    if ($(".spotgoods_postcard_slide").length) {
        var galleryThumbs = new Swiper(".spotgoods_postcard_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 8,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".spotgoods_postcard_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 8,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 進撃の日田公式スポットグッズ_ポストカード
    if ($(".SCAS_slide").length) {
        var galleryThumbs = new Swiper(".SCAS_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 8,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".SCAS_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 8,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }


    // 新着情報　トークショー告知
    if ($(".talk_show_info_slide").length) {
        var galleryThumbs = new Swiper(".talk_show_info_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".talk_show_info_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　デジタル展示
    if ($(".annex_immersive_comic_slide").length) {
        var galleryThumbs = new Swiper(".annex_immersive_comic_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".annex_immersive_comic_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　大山ダム２周年 銅像磨き
    if ($(".oyama_statue_2nd_polishing_slide").length) {
        var galleryThumbs = new Swiper(
            ".oyama_statue_2nd_polishing_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(".oyama_statue_2nd_polishing_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　リヴァイ兵士長像２周年お知らせ
    if ($(".levi_statue_2nd_anniversary_event_slide").length) {
        var galleryThumbs = new Swiper(
            ".levi_statue_2nd_anniversary_event_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(
            ".levi_statue_2nd_anniversary_event_slide",
            {
                initialSlide: 0,
                spaceBetween: 0,
                loop: true,
                loopedSlides: 3,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            }
        );
    }
    // 新着情報　トークショーお知らせ
    if ($(".talk_show_slide").length) {
        var galleryThumbs = new Swiper(".talk_show_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".talk_show_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　トークショーお知らせ
    if ($(".talk_show_application_slide").length) {
        var galleryThumbs = new Swiper(".talk_show_application_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".talk_show_application_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　トークショーお知らせ
    if ($(".talk_show_application_slide").length) {
        var galleryThumbs = new Swiper(".talk_show_application_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".talk_show_application_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　新ビジュアル
    if ($(".museum_new_tapestry_slide").length) {
        var galleryThumbs = new Swiper(".museum_new_tapestry_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".museum_new_tapestry_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　リヴァイ兵士長像２周年
    if ($(".levi_statue_2nd_anniversary_slide").length) {
        var galleryThumbs = new Swiper(
            ".levi_statue_2nd_anniversary_slide_thumb",
            {
                initialSlide: 0,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            }
        );
        var galleryTop = new Swiper(".levi_statue_2nd_anniversary_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　観光協会シャトルバス
    if ($(".shuttle_bus2310_slide").length) {
        var galleryThumbs = new Swiper(".shuttle_bus2310_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".shuttle_bus2310_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　シャトルバス
    if ($(".shuttle_bus_20231111_slide").length) {
        var galleryThumbs = new Swiper(".shuttle_bus_20231111_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".shuttle_bus_20231111_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　銅像三周年　お知らせ
    if ($(".oyama_statue_3rd_slide").length) {
        var galleryThumbs = new Swiper(".oyama_statue_3rd_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".oyama_statue_3rd_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　銅像三周年　報告
    if ($(".oyama_statue_3rd_event_slide").length) {
        var galleryThumbs = new Swiper(".oyama_statue_3rd_event_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".oyama_statue_3rd_event_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　銅像4周年　報告
    if ($(".oyama_statue_4th_event_slide").length) {
        var galleryThumbs = new Swiper(".oyama_statue_4th_event_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".oyama_statue_4th_event_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 植樹１周年
    if ($(".tree_1st_anniversary_slide").length) {
        var galleryThumbs = new Swiper(".tree_1st_anniversary_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".tree_1st_anniversary_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // エレン誕生日記念パーティー
    if ($(".eren_birthday_2502_slide").length) {
        var galleryThumbs = new Swiper(".eren_birthday_2502_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".eren_birthday_2502_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    if ($(".canal2412_slide").length) {
        var galleryThumbs = new Swiper(".canal2412_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".canal2412_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 進撃の日田 リヴァイ兵士長ハッピーバースデー＆ハッピーホリデー
    if ($(".levi_birthday_2024_slide").length) {
        var galleryThumbs = new Swiper(".levi_birthday_2024_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".levi_birthday_2024_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新ポストカード登場
    if ($(".new_postcard_slide").length) {
        var galleryThumbs = new Swiper(".new_postcard_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".new_postcard_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 進撃の日田CAFE移転リニューアルオープン！
    if ($(".cafe_relocation_open_slide").length) {
        var galleryThumbs = new Swiper(".cafe_relocation_open_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".cafe_relocation_open_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 進撃の日田CAFE　移転のお知らせ 詳細情報
    if ($(".cafe_relocation_detail_slide").length) {
        var galleryThumbs = new Swiper(".cafe_relocation_detail_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".cafe_relocation_detail_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 進撃の日田 エレンハッピーバースデー企画
    if ($(".eren_birthday_2025_slide").length) {
        var galleryThumbs = new Swiper(".eren_birthday_2025_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".eren_birthday_2025_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 『進撃の巨人 リヴァイ兵士長像』建立４周年！感謝を込めて銅像磨きを行います！（追加情報）
    if ($(".levi_4th_thank_you_gift_slide").length) {
        var galleryThumbs = new Swiper(".levi_4th_thank_you_gift_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".levi_4th_thank_you_gift_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 進撃の日田公式スポットポストカード６枚セット　新登場！
    if ($(".ts_new_goods_postcard_slide").length) {
        var galleryThumbs = new Swiper(".ts_new_goods_postcard_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".ts_new_goods_postcard_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 『進撃の巨人 リヴァイ兵士長像』建立４周年！感謝を込めて銅像磨きを行います！（イベント詳細案内）
    if ($(".levi_4th_2502_slide").length) {
        var galleryThumbs = new Swiper(".levi_4th_2502_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".levi_4th_2502_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // キャナルイベント
    if ($(".canal2412_slide").length) {
        var galleryThumbs = new Swiper(".canal2412_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".canal2412_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // アニメ＆まんが聖地EXPO2024
    if ($(".ampse2024_slide").length) {
        var galleryThumbs = new Swiper(".ampse2024_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".ampse2024_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }

    // 新着情報　スターフライヤースペシャルジェット
    if ($(".starflyer_special_jet_slide").length) {
        var galleryThumbs = new Swiper(".starflyer_special_jet_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".starflyer_special_jet_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　 パブリックビューイングのお知らせ
    if ($(".public_viewing_slide").length) {
        var galleryThumbs = new Swiper(".public_viewing_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".public_viewing_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // 新着情報　おもてなし看板
    if ($(".omotenashi_kanban_slide").length) {
        var galleryThumbs = new Swiper(".omotenashi_kanban_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".omotenashi_kanban_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 6,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // AR
    if ($(".ar_slide").length) {
        var galleryThumbs = new Swiper(".ar_slide_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".ar_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 3,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // レンタサイクルスライドショー
    if ($(".rental_cycle_slide").length) {
        var galleryThumbs = new Swiper(".rental_cycle_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".rental_cycle_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 5,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    // レンタサイクルスライドショー
    if ($(".stamp_collecting_slide").length) {
        var galleryThumbs = new Swiper(".stamp_collecting_thumb", {
            initialSlide: 0,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper(".stamp_collecting_slide", {
            initialSlide: 0,
            spaceBetween: 0,
            loop: true,
            loopedSlides: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    /*
     ** page内アンカー
     */
    var headerHeight = $("header").outerHeight() + $(".gnav").outerHeight();
    var urlHash = location.hash;
    if (urlHash) {
        $("body,html").stop().scrollTop(0);
        setTimeout(function () {
            var target = $(urlHash);
            var position = target.offset().top - headerHeight;
            $("body,html").stop().animate({ scrollTop: position }, 500);
        }, 100);
    }
    $('a[href^="#"]').on("click", function () {
        var href = $(this).attr("href");
        var target = $(href);
        var position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, 500);
    });

    /*
     ** 初期言語設定
     */
    (function () {
        var lang = localStorage.getItem("lang");
        if (lang == "" || lang == null) {
            localStorage.setItem("lang", "ja");
            lang = "ja";
        }

        // if(lang === 'ja') {
        //   $('.gnav').removeClass('less');
        //   $('.lang_en_hide').show();
        //   $('.lang_en_show').hide();
        // } else {
        //   $('.gnav').addClass('less');
        //   $('.lang_en_hide').hide();
        //   $('.lang_en_show').show();
        // };
        if (lang === "ja") {
            $(".gnav").removeClass("less");
            $(".lang_en_hide").show();
            $(".lang_ja").show();
            $(".lang_en_show").hide();
            $(".lang_kr_show").hide();
        } else if (lang === "en") {
            $(".gnav").addClass("less");
            $(".lang_en_show").show();
            $(".lang_en").show();
            $(".lang_en_hide").hide();
            $(".lang_kr_show").hide();
        } else if (lang === "kr") {
            $(".gnav").addClass("less");
            $(".lang_kr_show").show();
            $(".lang_kr").show();
            $(".lang_en_hide").hide();
            $(".lang_en_show").hide();
        } else if (lang === "zh") {
            $(".gnav").addClass("less");
            $(".lang_zh_show").show();
            $(".lang_zh").show();
            $(".lang_en_hide").hide();
            $(".lang_en_show").hide();
        }
    })();

    /*
     ** Glottologist
     ** creative ./language.json
     */
    /*
  var global_lang_data = {};

  var lang_get = (name, lang = "auto", obj = {}) => {
    let data = {}
    if (typeof lang == 'object') {
      data = lang
      lang = typeof obj == 'string' ? obj : "auto"
    };

    let tmp;
    let result;
    if (lang == "auto") {
      tmp = global_lang_data[name][new String(lang).split("-")[0]]
      result = tmp == undefined ? global_lang_data[name][Object.keys(global_lang_data[name])[0]] : tmp
    } else {
      tmp = global_lang_data[name][lang];
      result = tmp == undefined ? global_lang_data[name][Object.keys(global_lang_data[name])[0]] : tmp
    };

    return "\`" + result + "\`" //libraryではevalを使っていたがIE11で動かないし、計算式なんかないので消した。
  };

  var lang_render = function() {
    var lang = localStorage.getItem('lang');
    if(lang == null) {
      lang = 'ja'
    };

    const elements = document.querySelectorAll("[glot-model]");
    for (let i=0; i<elements.length; i++) {
      const attr = elements[i].getAttribute("glot-model");
      elements[i].innerHTML = lang_get(attr, lang);
    };
  }

  var lang_url = '../language.json';
  var lang_import = function(url) {
    return new Promise((resolve, reject) => {
      fetch(url).then(res => {
        res.json().then(data => {
          global_lang_data = Object.assign(global_lang_data, data);
          resolve(lang_render())
        }).catch(e => {
          reject(e)
        })
      }).catch(e => {
        reject(e)
      })
    });
  };

  lang_import(lang_url);
  */

    glot.import("/language.json").then(() => {
        var lang = localStorage.getItem("lang");
        if (lang == null) {
            lang = "ja";
        }
        glot.render(lang);
    });

    //ios form zoom 禁止
    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
        var viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
            var viewportContent = viewport.getAttribute("content");
            viewport.setAttribute(
                "content",
                viewportContent + ", user-scalable=no"
            );
        }
    }

    /*
     ** Validate prize
     */
    if ($("#contact_prize_form").length) {
        $("#zipcode").on("blur", function () {
            $('input[name="address1"]').valid();
            $('input[name="address2"]').valid();
        });

        //auto kana
        $("#name1").on("blur", function () {
            $(this).val(
                new Moji($(this).val())
                    .convert("HK", "ZK")
                    .convert("HE", "ZE")
                    .toString()
                    .replace(/ /g, "　")
            );
            $(this).val($.trim($(this).val()));

            setTimeout(function () {
                var target = $("#kana1");
                target.val(
                    new Moji(target.val())
                        .convert("HK", "ZK")
                        .convert("HE", "ZE")
                        .toString()
                        .replace(/ /g, "　")
                );
            }, 1);
        });
        AutoKana.bind("#name1", "#kana1", { katakana: true });

        $("#name2").on("blur", function () {
            $(this).val(
                new Moji($(this).val())
                    .convert("HK", "ZK")
                    .convert("HE", "ZE")
                    .toString()
                    .replace(/ /g, "　")
            );
            $(this).val($.trim($(this).val()));

            setTimeout(function () {
                var target = $("#kana2");
                target.val(
                    new Moji(target.val())
                        .convert("HK", "ZK")
                        .convert("HE", "ZE")
                        .toString()
                        .replace(/ /g, "　")
                );
            }, 1);
        });
        AutoKana.bind("#name2", "#kana2", { katakana: true });

        $("#kana1, #kana2").on("blur", function () {
            $(this).val(
                new Moji($(this).val())
                    .convert("HG", "KK")
                    .convert("HK", "ZK")
                    .convert("HE", "ZE")
                    .toString()
                    .replace(/ /g, "　")
            );
            $(this).val($.trim($(this).val()));
        });

        $.extend($.validator.messages, {
            required: "必須項目です。",
            equalTo: "メールアドレスが一致しません。",
            isMail: "正しいメールアドレスを入力ください。",
            isZip: "正しい郵便番号でご入力ください。",
            isPhone: "正しい電話番号でご入力ください。",
        });

        var methods = {
            isMail: function (value, element) {
                var mail = value.split("@");
                if (mail[0].slice(0, 1) === "." || mail[0].slice(-1) === ".") {
                    return false;
                }

                if (value.slice(-1) === ".") {
                    return false;
                }

                if (value.indexOf("..") !== -1) {
                    return false;
                }

                return (
                    this.optional(element) ||
                    /^[a-zA-Z0-9!#$%'*+/=?^_`{|}~.-]+@[0-9a-zA-Z-]+\.[0-9a-zA-Z.-]+$/.test(
                        value
                    )
                );
            },
            isPhone: function (value, element) {
                //固定電話、携帯電話兼用。
                value = value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, "");
                return (
                    this.optional(element) ||
                    /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(value)
                );
            },
            isZip: function (value, element) {
                // value = value.replace(/\D/g ,"");
                return this.optional(element) || /^\d{7}$/.test(value);
            },
        };

        $.each(methods, function (key) {
            $.validator.addMethod(key, this);
        });

        $("#contact_prize_form").validate({
            rules: {
                name1: {
                    required: true,
                },
                name2: {
                    required: true,
                },
                kana1: {
                    required: true,
                },
                kana2: {
                    required: true,
                },
                zipcode: {
                    required: true,
                    isZip: true,
                    maxlength: 7,
                },
                prefecture: {
                    required: true,
                },
                address1: {
                    required: true,
                },
                address2: {
                    required: true,
                },
                telno: {
                    required: true,
                    isPhone: true,
                    maxlength: 11,
                },
                email: {
                    required: true,
                    isMail: true,
                },
                email_confirmation: {
                    required: true,
                    isMail: true,
                    equalTo: "#email",
                },
                privacypolicy: {
                    required: true,
                },
            },
            messages: {
                zipcode: {
                    maxlength: "7文字以内でご入力ください。",
                },
                telno: {
                    maxlength: "11文字以内でご入力ください。",
                },
            },
            errorElement: "span",
            errorClass: "err",
            errorPlacement: function (error, element) {
                if (element.attr("id") == "privacypolicy") {
                    var target = $("#privacypolicy").closest("label");
                    error.insertAfter(target).addClass("err_msg");
                } else {
                    error.insertAfter(element).addClass("err_msg");
                }
            },
        });
    }

    /*
     ** Validate en prize
     */
    if ($("#contact_prize_form_en").length) {
        $("#zip").on("blur", function () {
            $('input[name="address1"]').valid();
            $('input[name="address2"]').valid();
        });

        $.extend($.validator.messages, {
            required: "Required item.",
            equalTo: "The email addresses do not match.",
            isMail: "Please enter a valid email.",
            isZip: "Please enter a valid ZIP/Postal code.",
            isPhone: "Please enter a valid Phone number.",
        });

        var methods = {
            isMail: function (value, element) {
                var mail = value.split("@");
                if (mail[0].slice(0, 1) === "." || mail[0].slice(-1) === ".") {
                    return false;
                }

                if (value.slice(-1) === ".") {
                    return false;
                }

                if (value.indexOf("..") !== -1) {
                    return false;
                }

                return (
                    this.optional(element) ||
                    /^[a-zA-Z0-9!#$%'*+/=?^_`{|}~.-]+@[0-9a-zA-Z-]+\.[0-9a-zA-Z.-]+$/.test(
                        value
                    )
                );
            },
            isPhone: function (value, element) {
                //固定電話、携帯電話兼用。
                value = value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, "");
                return (
                    this.optional(element) ||
                    /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(value)
                );
            },
            isZip: function (value, element) {
                // value = value.replace(/\D/g ,"");
                return this.optional(element) || /^\d{7}$/.test(value);
            },
        };

        $.each(methods, function (key) {
            $.validator.addMethod(key, this);
        });

        $("#contact_prize_form_en").validate({
            rules: {
                name_sei: {
                    required: true,
                },
                name_mei: {
                    required: true,
                },
                zip: {
                    required: true,
                    isZip: true,
                },
                zipcode: {
                    required: true,
                    isZip: true,
                },
                prefecture: {
                    required: true,
                },
                address1: {
                    required: true,
                },
                address2: {
                    required: true,
                },
                address3: {
                    required: true,
                },
                tel: {
                    required: true,
                    isPhone: true,
                },
                telno: {
                    required: true,
                    isPhone: true,
                },
                email: {
                    required: true,
                    isMail: true,
                },
                email_cnf: {
                    required: true,
                    isMail: true,
                    equalTo: "#email",
                },
                email_confirmation: {
                    required: true,
                    isMail: true,
                    equalTo: "#email",
                },
                check: {
                    required: true,
                },
            },
            errorElement: "span",
            errorClass: "err",
            errorPlacement: function (error, element) {
                if (element.attr("id") == "check") {
                    var target = $("#check").closest("label");
                    error.insertAfter(target).addClass("err_msg");
                } else {
                    error.insertAfter(element).addClass("err_msg");
                }
            },
        });
    }

    /*
     ** Validate question
     */
    if ($("#contact_question_form").length) {
        $.extend($.validator.messages, {
            required: "必須項目です。",
            isMail: "正しいメールアドレスを入力ください。",
        });

        var methods = {
            isMail: function (value, element) {
                var mail = value.split("@");
                if (mail[0].slice(0, 1) === "." || mail[0].slice(-1) === ".") {
                    return false;
                }

                if (value.slice(-1) === ".") {
                    return false;
                }

                if (value.indexOf("..") !== -1) {
                    return false;
                }

                return (
                    this.optional(element) ||
                    /^[a-zA-Z0-9!#$%'*+/=?^_`{|}~.-]+@[0-9a-zA-Z-]+\.[0-9a-zA-Z.-]+$/.test(
                        value
                    )
                );
            },
        };

        $.each(methods, function (key) {
            $.validator.addMethod(key, this);
        });

        $("#contact_question_form").validate({
            rules: {
                email: {
                    required: true,
                    isMail: true,
                },
                nickname: {
                    required: true,
                },
                question: {
                    required: true,
                },
            },
            errorElement: "span",
            errorClass: "err",
            errorPlacement: function (error, element) {
                error.insertAfter(element).addClass("err_msg");
            },
        });
    }

    if ($(".fade-up").length) {
        const objects = document.querySelectorAll('.fade-up');
        const cb = function (entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('scroll_displayed_up');//スクロール感知で「displayed」のクラス名を付与
                    observer.unobserve(entry.target); //監視の終了
                }
            });
        }
        const options = { root: null, rootMargin: "0px", threshold: 0.3 }
        const io = new IntersectionObserver(cb, options);
        objects.forEach(object => {
            io.observe(object);
        });
    }
    if ($(".fade-in").length) {
        const objects = document.querySelectorAll('.fade-in');
        const cb = function (entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('scroll_displayed_in');//スクロール感知で「displayed」のクラス名を付与
                    observer.unobserve(entry.target); //監視の終了
                }
            });
        }
        const options = { root: null, rootMargin: "0px", threshold: [0.5] }
        const io = new IntersectionObserver(cb, options);
        objects.forEach(object => {
            io.observe(object);
        });
    }
});

export default ModuleGeneral;
